// extracted by mini-css-extract-plugin
export var button = "_n6-2";
export var card = "_n6-0";
export var closeButtonContainer = "_n6-3";
export var iconContainer = "_n6-1";